define("Magento_Ui/js/lib/logger/entry",["./levels-pool"],function(e){"use strict";return function(t,i,s){this.timestamp=Date.now(),this.level=i,this.levelName=e.getNameByCode(i),this.data=s,this.message=t}});
